var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMazarsLogo = function SvgMazarsLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    viewBox: "0 0 160 26",
    width: 320,
    height: 52,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.9,
    y: 0.9,
    fill: "#B70D18",
    stroke: "#B70D18",
    strokeWidth: 0.7379,
    width: 24,
    height: 23.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.9,
    y: 0.5,
    fill: "#005693",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F9B000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4,17.3l0.5,0.5l1.5-1.5c-0.2-0.2-0.3-0.4-0.5-0.6L30.4,17.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5,18.4l0.5,0.5l1.6-1.6c-0.2-0.1-0.4-0.3-0.6-0.5L31.5,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6,18.9l0.5-0.5l-1.5-1.5c-0.2,0.2-0.4,0.3-0.6,0.5L41.6,18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2,16.3l1.5,1.5l0.5-0.5l-1.6-1.6C41.5,15.9,41.4,16.1,41.2,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2,7.8l-0.5-0.5l-1.5,1.5c0.2,0.2,0.3,0.4,0.5,0.6L43.2,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1,6.7l-0.5-0.5L40,7.7c0.2,0.1,0.4,0.3,0.6,0.5L42.1,6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1,6.1l-0.5,0.5l1.5,1.5c0.2-0.2,0.4-0.3,0.6-0.5L32.1,6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,7.2l-0.5,0.5L32,9.4c0.1-0.2,0.3-0.4,0.5-0.6L31,7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2,11.6l-4.9,0.9l4.9,0.9c0-0.3-0.1-0.6-0.1-0.9C31.1,12.2,31.1,11.9,31.2,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9,18.2l0.9,4.9l0.9-4.9c-0.3,0-0.6,0.1-0.9,0.1C36.5,18.3,36.2,18.3,35.9,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5,13.4l4.9-0.9l-4.9-0.9c0,0.3,0.1,0.6,0.1,0.9C42.6,12.8,42.6,13.1,42.5,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7,6.8l-0.9-4.9l-0.9,4.9c0.3,0,0.6-0.1,0.9-0.1C37.1,6.8,37.4,6.8,37.7,6.8z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#005693"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.5,15.6l-5.3-9.4h-0.6L57.8,16c-0.1,1.3-0.3,1.9-1.1,2.1v0.4c0.5,0,1-0.1,1.6-0.1c0.5,0,1,0.1,1.6,0.1 v-0.4c-0.7-0.1-1-0.6-1-1.5c0-0.4,0.1-0.9,0.1-1.1l0.3-5.1h0l4.9,8.2l3.9-8h0l0.5,5.2c0,0.2,0.1,0.6,0.1,1.2 c0,0.6-0.2,1.1-0.8,1.2v0.4c0.6,0,1.2-0.1,1.8-0.1c0.6,0,1.2,0.1,1.8,0.1v-0.4c-0.7,0-0.9-0.8-1-1.7L69.7,6.2h-0.5L64.5,15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4,8.8c0.1-0.7,0.6-1.4,1.4-1.4h5.8l-8.1,11h8.8c0.8,0,1.4,0,1.9,0.3l0.5-2.4l-0.6-0.1 c-0.3,0.9-1.1,1.2-3.8,1.2c-1.2,0-2.5-0.1-3.7-0.1l8.4-10.8H97.6c-0.3,0-0.6-0.1-0.9-0.1v2.5L97.4,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.4,6.8c-1-0.5-2.2-0.7-3.4-0.7c-2.2,0-4.1,1.5-4.1,3.8c0,4.5,5.9,2.8,5.9,5.8c0,1.3-1,2.2-2.3,2.2 c-1.1,0-2.3-0.8-2.6-1.9h-0.6l0.2,1.9c0.6,0.4,2,0.8,3.1,0.8c2,0,4-1.3,4-3.5c0-4.7-5.9-2.4-5.9-6.1c0-1.2,1.1-2.2,2.3-2.2 c1.3,0,2.4,0.5,2.8,1.8h0.7V6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6,14.9l0.6,1.6c0.1,0.3,0.2,0.6,0.2,0.9c0,0.4-0.2,0.6-0.6,0.6v0.4c0.6,0,1.2-0.1,1.8-0.1 c0.6,0,1.2,0.1,1.7,0.1v-0.4c-0.6-0.1-0.8-0.6-1.4-2.2l-3.8-9.7H84l-3.7,9.3c-0.3,0.8-1,2.5-1.7,2.6v0.4c0.5,0,1-0.1,1.5-0.1 c0.5,0,1,0.1,1.5,0.1v-0.4c-0.4,0-0.6-0.3-0.6-0.7c0-0.2,0-0.6,0.1-0.9l0.5-1.5H85.6z M81.9,14.1l1.7-4.6l1.7,4.6H81.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.6,14.9l0.6,1.6c0.1,0.3,0.2,0.6,0.2,0.9c0,0.4-0.2,0.6-0.6,0.6v0.4c0.6,0,1.2-0.1,1.7-0.1 c0.6,0,1.2,0.1,1.7,0.1v-0.4c-0.6-0.1-0.8-0.6-1.4-2.2l-3.8-9.7h-0.2l-3.7,9.3c-0.3,0.8-1,2.5-1.7,2.6v0.4c0.5,0,1-0.1,1.5-0.1 c0.5,0,1,0.1,1.5,0.1v-0.4c-0.4,0-0.6-0.3-0.6-0.7c0-0.2,0-0.6,0.1-0.9l0.5-1.5H121.6z M117.8,14.1l1.7-4.6l1.7,4.6H117.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.5,7.5c0-0.4,0.5-0.5,0.9-0.5c1.9,0,2.6,1.4,2.6,3c0,1.6-1.4,2.7-3,2.7c-0.2,0-0.4,0-0.7-0.1 L136.5,7.5z M133.7,18.5c0.6,0,1.2-0.1,1.8-0.1c0.6,0,1.2,0.1,1.9,0.1v-0.4c-0.9-0.2-1-0.7-1-1.4v-3.4c0.4,0,0.8,0.5,1,0.7 l2.9,3.4c0.2,0.2,0.3,0.4,0.3,0.6c0,0.1-0.1,0.2-0.2,0.2v0.4c0.6,0,1.1-0.1,1.7-0.1s1.2,0.1,1.7,0.1v-0.4c-0.5-0.1-1.1-0.7-1.3-1 l-3.5-4.1c1.5-0.4,3.1-1.5,3.1-3.3c0-1.9-1.5-3.4-4.6-3.4c-1.3,0-1.8,0.1-2.3,0.1c-0.6,0-1.1-0.1-1.7-0.1v0.4c0.9,0.2,1,0.6,1,1.4 c0,1.5,0.1,3,0.1,4.5v4.5c0,0.6-0.3,0.9-0.9,1V18.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F9B000",
    d: "M13.1,16l4.8-9.9h0.3l0.5,10.3c0.1,1.4,0.2,1.6,0.9,1.7v0.3c-0.5,0-1-0.1-1.6-0.1c-0.5,0-1,0.1-1.5,0.1 v-0.3c0.7-0.1,0.9-0.6,0.9-1.2c0-0.7,0-1.2-0.1-1.5L17,9.3H17L12.7,18l-5-8.7H7.6l-0.3,5.4c0,0.4,0,1.2,0,1.7 c0,1.2,0.5,1.6,1.1,1.7v0.3c-0.5,0-1-0.1-1.5-0.1c-0.5,0-1,0.1-1.5,0.1v-0.3c0.9-0.2,1.1-0.5,1.2-2l0.7-10h0.3L13.1,16z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMazarsLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mazars-logo.c092e741.svg";
export { ForwardRef as ReactComponent };